import React from 'react'
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
    ctaContainer: {
        display: 'grid',
        alignItems: 'center',
        padding: '20px 0',
        '@media screen and (max-width: 480px)': {
            display: 'grid',
            alignItems: 'center',
            padding: '15px 0',
        }
    },  
    ctaBtn: {
        backgroundColor: 'var(--tertiary-color)',
        marginLeft: 'auto',
        marginRight: 'auto',
        borderRadius: '20px',
        padding: '20px 30px',
        cursor: 'pointer',
        display: 'inline-block',
        fontWeight: 'bold',
        fontSize: '20px',
        color: 'rgba(255, 255, 255, 0.9)',
        marginBottom: '15px',
        transition: '0.1s background-color ease',
        outline: '0',
        textDecoration: 'none',
        '&:hover': {
            backgroundColor: 'var(--tertiary-color-hover)',
            color: 'rgba(255, 255, 255, 0.9)',
        },
        '@media screen and (max-width: 480px)': {
            backgroundColor: 'var(--tertiary-color)',
            borderRadius: '15px',
            padding: '15px 25px',
            fontSize: '16px',
            marginBottom: '15px',
            textAlign: 'center',
        }
    },
    ctaSubtitle: {
        textAlign: 'center',
        '@media screen and (max-width: 480px)': {
            textAlign: 'center',
            fontSize: '14px',
        }
    },
});

function CTAButton() {

    var nextDay = new Date();
    nextDay.setDate(nextDay.getDate() + 1);

    var month = nextDay.getMonth();
    var day = nextDay.getDate();
    var year = nextDay.getFullYear();
    const months = {
        0: 'January',
        1: 'February',
        2: 'March',
        3: 'April',
        4: 'May',
        5: 'June',
        6: 'July',
        7: 'August',
        8: 'September',
        9: 'October',
        10: 'November',
        11: 'December'
    }

    var date = day + " " + months[month] + " " + year

    var classes = useStyles()

    return (
        <div className={classes.ctaContainer}>
            <div className={classes.ctaBtn + " cta-btn"}>
            Register now to become an agent of change for ₹499! <span style={{textDecoration: "line-through"}}>₹999</span>
            </div>
            <div className={classes.ctaSubtitle}>
                Limited Seats only! Hurry Up and Grab your seat by {date}
            </div>
        </div>
    )
}

export default CTAButton
